// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qlP5","left":"styles_left__vhZ87"};